import React from "react";
import Tick from "../../Assets/tick.png";

interface Props {
  heading: Array<string>;
  rows: Array<Array<boolean | string | null>>;
}

const Table = (props: Props) => {
  let heading = [];
  let rows = [];
  for (let i = 0; i < props.heading.length; i++) {
    heading.push(<th>{props.heading[i]}</th>);
  }
  for (let i = 0; i < props.rows.length; i++) {
    let temp = [];
    for (let j = 0; j < props.rows[i].length; j++) {
      temp.push(
        <td colSpan={props.heading.length !== props.rows[i].length && j !== 0 ? props.heading.length - 1 : 1}>
          {typeof props.rows[i][j] === "string" ? props.rows[i][j] : props.rows[i][j] ? <img src={Tick} alt="Tick" /> : ""}
        </td>
      );
    }
    rows.push(<tr>{temp}</tr>);
  }
  return (
    <table>
      <tr>{heading}</tr>
      {rows}
    </table>
  );
};

export default Table;
